module.exports = __webpack_public_path__ + "static/media/arrowLeft.9ee385fc.svg";